<script lang="ts">
  import { getContext } from "svelte";
  import { NavbarDrawer, type NavbarStore } from "@agapi/ui/navbar";

  import { MiniCart } from "../../minicart";
  import { EVENTS } from '../../../services';

  const navbar = getContext<NavbarStore>('navbar');

  EVENTS.addListener('cart_item_add', 'navbar', function (_event, param) {
    const { ignoreDrawer } = param as { ignoreDrawer?: boolean };
    if (!navbar.isDrawerOpen && !ignoreDrawer) {
      console.log('cart_item_add:openCart');
      navbar.openDrawer();
    }
  });
</script>

<NavbarDrawer css={{ background: 'transparent!' }} fullHeight={true}>
  <MiniCart />
</NavbarDrawer>
